// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"2494a326","720":"f4d4b277","809":"cf80a585","959":"e8abea26"}[chunkId] + ".chunk.js";
};